/* eslint-disable @typescript-eslint/no-explicit-any */

import * as React from "react";
import Triggers from "../../Triggers/Triggers";
import { TriggerActionCategory } from "client/resources/triggerResource";

export const RunbookTriggers: React.FC = (props: any) => {
    return <Triggers triggerActionCategory={TriggerActionCategory.Runbook} {...props} />;
};
